import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-dairy',
  templateUrl: './icon-dairy.component.html',
  styleUrls: ['./icon-dairy.component.scss']
})
export class IconDairyComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
